import React from 'react';
import ReactDOM from 'react-dom/client';
import { Chart as ChartJS } from 'chart.js';
import './index.css';
import App from './App';

ChartJS.defaults.font.family = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

// Suppress the benign ResizeObserver notification error thrown by Quill's
// internal resize handling — it does not affect functionality.
// Capture phase (3rd arg = true) ensures this runs before CRA's error overlay
// bubble-phase listener, so stopImmediatePropagation actually prevents the overlay.
window.addEventListener("error", (e) => {
  if (typeof e.message === "string" && e.message.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

// Also patch window.onerror for environments where the error bypasses the
// addEventListener path (e.g. some webpack overlay implementations).
const _origOnerror = window.onerror;
window.onerror = (message, source, line, col, error) => {
  if (typeof message === "string" && message.includes("ResizeObserver loop")) {
    return true;
  }
  return _origOnerror?.(message, source, line, col, error);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

